/**
 * UserTableContent - Table content component for user table.
 *
 * Displays the table structure with header and body rows.
 */

import { UserTableHeader } from './UserTableHeader';
import { UserTableRow } from './UserTableRow';
import type { UserResponse } from '@/lib/api';

export interface UserTableContentProps {
  /**
   * List of users to display.
   */
  users: UserResponse[];
  /**
   * Async callback when edit button is clicked.
   */
  onEdit: (user: UserResponse) => Promise<void>;
  /**
   * Async callback when delete button is clicked.
   */
  onDelete: (user: UserResponse) => Promise<void>;
  /**
   * Function to format date strings.
   */
  formatDate: (dateString: string | null | undefined) => string;
}

export function UserTableContent({ users, onEdit, onDelete, formatDate }: UserTableContentProps) {
  return (
    <div className="overflow-x-auto">
      <table className="w-full">
        <UserTableHeader />
        <tbody
          className="
            divide-y divide-border-default bg-bg-elevated
            dark:bg-bg-elevated
          "
        >
          {users.map((user) => (
            <UserTableRow key={user.id} user={user} onEdit={onEdit} onDelete={onDelete} formatDate={formatDate} />
          ))}
        </tbody>
      </table>
    </div>
  );
}
